import { InjectionToken } from '@angular/core';
export const chatbotApiUrl = new InjectionToken<string>('Chatbot API URL');
